export default __webpack_public_path__ + "static/solutions-triangle-acquisition.url-58bec5fb980e325b9ec9ac384fde37ed.svg";